
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/subscriptions/new",
      function () {
        return require("private-next-pages/admin/subscriptions/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/subscriptions/new"])
      });
    }
  